import { Cookies } from 'react-cookie';
import GoogleAnalyticsHandler from './GoogleAnalyticsHandler';

export default class CookiesHandler {
  constructor() {
    this.gaHandler = new GoogleAnalyticsHandler();
    this.cookies = new Cookies();
    this.domain = `.${window.location.hostname}`;
  }

  acceptCookies() {
    this.setAllowCookies(true);
    this.initThirdPartyCookies();
  }

  rejectCookies() {
    const gaCookies = this.gaHandler.cookiesList();

    gaCookies.forEach((cookieName) => {
      this.cookies.remove(cookieName, { path: '/', domain: this.domain });
    });

    this.setAllowCookies(false);
  }

  setAllowCookies(value) {
    if (typeof value === 'boolean') {
      this.cookies.set('allowCookies', value, {
        path: '/',
        domain: this.domain,
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // One year
      });
    }
  }

  resetAllowCookies() {
    this.cookies.remove('allowCookies', { path: '/', domain: this.domain });
  }

  isAllowCookies() {
    return this.cookies.get('allowCookies');
  }

  initThirdPartyCookies() {
    if (this.isAllowCookies() === true) {
      this.gaHandler.initialize();
    }
  }
}
